import { memo } from 'react'
import { Zap } from 'lucide-react'
import { AttachmentStub } from '../attachment-stub'
import type { AttachmentPillProps } from '../types'

/**
 * Scoped-target pill: the staged action riding on the input while its Action
 * View is open. Informational — closing the view detaches it, so it carries no
 * remove affordance.
 */
export const StagedActionAttachment = memo((attachment: AttachmentPillProps) => {
  const pending = attachment.pending?.type === 'stagedAction' ? attachment.pending : null
  const icon = pending?.view?.icon
  const hasIconUrl = typeof icon === 'string' && (icon.startsWith('http') || icon.startsWith('data'))
  return (
    <AttachmentStub
      label={pending?.view?.title || pending?.title || 'Action'}
      image={hasIconUrl ? icon : undefined}
      icon={hasIconUrl ? undefined : <Zap size={16} />}
      // Wears the removable input-pill chrome despite having no remove
      // affordance, so it doesn't stand out from its bar neighbors.
      className="hover:bg-element text-foreground-secondary hover:text-foreground bg-background shadow-xs border-transparent"
    />
  )
})
StagedActionAttachment.displayName = 'StagedActionAttachment'
